<template>
  <p>Welcome</p>
</template>
<script>
export default {
  name: "Dashboard",
};
</script>